/**
 * Wat je ziet als er iets omvalt waar de app niet meer uitkomt.
 *
 * Beter dan een wit scherm, en dat is precies wat het anders was. De dc-runtime
 * had hier iets voor; bij de overzetting is dat weggevallen en nu staat het er
 * weer, maar dan in de huisstijl in plaats van een rood ontwikkelaarsbalkje.
 *
 * Je krabbel is niet weg: die staat in de browser opgeslagen en komt terug na het
 * herladen.
 */
export default function Crashed({ error, onReload }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'var(--room)',
        color: 'var(--ink)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: "'Fredoka', system-ui, sans-serif"
      }}
    >
      <div
        style={{
          background: '#fff',
          border: '4px solid var(--ink)',
          borderRadius: '24px',
          boxShadow: '8px 8px 0 var(--ink)',
          padding: '26px',
          width: 'min(460px, 100%)',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
      >
        <div style={{ fontSize: '19px', fontWeight: 700 }}>De paal is even omgevallen</div>

        <div style={{ fontSize: '15px', fontWeight: 600, lineHeight: 1.4 }}>
          Er ging hier iets mis wat we niet hadden zien aankomen. Je krabbel is niet weg:
          die staat in je browser en komt terug zodra je opnieuw laadt.
        </div>

        {error ? (
          <div
            style={{
              fontSize: '12px',
              fontWeight: 600,
              color: 'var(--tekst-2)',
              background: 'var(--lila)',
              border: '3px solid var(--lila-diep)',
              borderRadius: '12px',
              padding: '10px 12px',
              wordBreak: 'break-word',
              maxHeight: '120px',
              overflowY: 'auto'
            }}
          >
            {String(error)}
          </div>
        ) : null}

        {/* Eén knop in een venster is altijd zo breed als het venster. */}
        <button
          onClick={onReload}
          className="gp-btn pink"
          style={{ width: '100%', justifyContent: 'center', fontSize: '16px', padding: '12px' }}
        >
          Opnieuw laden
        </button>
      </div>
    </div>
  );
}
